import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Dynamic radio button group that generates up to 4 options from configuration.
 * Automatically translates option labels and handles state management.
 * @param {Object} props
 * @param {Object} props.element - Configuration element with option 1-4 properties
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function RadioButton({ element, parameters, setParameters }) {
  const { t } = useLanguage()

  if (!element) {
    return <div className="row radioButton" />
  }

  /**
   * Updates the selected radio option in parameters.
   * @param {Event} event
   */
  const radioChange = event => {
    if (setParameters && parameters) {
      setParameters({ ...parameters, [element.id]: event.target.value })
    }
  }

  const radioHtml = []

  for (var i = 1; i <= 4; i++) {
    let opt = `option${i}`
    if (element[opt]) {
      const optionValue = element[opt]
      const translatedOption = typeof t === "function" ? t(optionValue) || optionValue : optionValue
      radioHtml.push(
        <div key={i} className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name={`radioOptions-${element.id || "default"}`}
            id={`options-${element[opt]}`}
            value={optionValue}
            checked={parameters && parameters[element.id] === optionValue}
            onChange={event => radioChange(event)}
          />
          <label className="form-check-label" htmlFor={`options-${element.id || "default"}-${element[opt]}`}>
            {translatedOption}
          </label>
        </div>
      )
    }
  }

  return (
    <div className="row radioButton">
      <div className="col-5">
        <InfoPopover element={element} />
        <span>{element?.label ? (typeof t === "function" ? t(element.label) : element.label) : element?.label}</span>
      </div>
      <div className="col">{radioHtml}</div>
    </div>
  )
}

export default RadioButton
